import { registerMessages } from "../../i18n/runtime";
import { expensesNavEn } from "./messages.en";

// Imported by the module definition, not by the lazy screens: the sidebar needs these labels before any screen has loaded.
registerMessages("en", expensesNavEn);
